async function bootApp() {
  return require('./App');
}

bootApp();
